module.exports = __webpack_public_path__ + "media/images/smart_phone/info_2-139e2ee694dbcca0d0754d239772e649.png";